
export function generate(){
    return [
        {
          question:
            "Which of the following best describes your current role. (Choose all that apply)",
          type: "checkbox",
          visualized: false,
          options: [
            { label: "Principal", checked: false },
            { label: "Assistant /Vice Principal", checked: false },
            { label: "Curriculum Director", checked: false },
            { label: "Technology Director", checked: false },
            { label: "Technology Support Staff (IT)", checked: false },
            {
              label: "Technology Support Staff (Pedagogical focus)",
              checked: false,
            },
            { label: "Administrative Support", checked: false },
            { label: "Teacher", checked: false },
          ],
        },
        {
          question:
            "Which of the following best defines your school (check all that apply)",
          type: "radiogroup",
          visualized: false,
          selected: "",
          options: [
            { label: "Public school" },
            { label: "Charter School" },
            { label: "Private School" },
            { label: "Christian/Parochial School" },
          ],
        },
        // {
        //   question: "Please select your school name",
        //   type: "dropdown",
        //   selected: "",
        //   visualized: false,
        //   options: [
        //     { label: "Nam's school" },
        //     { label: "Damian's School" },
        //     { label: "Holly's School" },
        //     { label: "Ruben's School" },
        //   ],
        // },
        {
          question:
            "Which of the following best describes your school (please check all that apply)",
          type: "checkbox",
          visualized: true,
          options: [
            {
              label: "Early Learning/ Pre-K",
              checked: false,
              image: "assets/visualmap/Q2/Q2R1.png",
            },
            {
              label: "Elementary School",
              checked: false,
              image: "assets/visualmap/Q2/Q2R2.png",
            },
            {
              label: "Middle School",
              checked: false,
              image: "assets/visualmap/Q2/Q2R3.png",
            },
            {
              label: "High School",
              checked: false,
              image: "assets/visualmap/Q2/Q2R4.png",
            },
          ],
        },
        {
          question: "What describes your school?",
          type: "radiogroup",
          visualized: true,
          selected: "",
          options: [
            { label: "Urban", image: "assets/visualmap/Q3/Q3R1.png" },
            { label: "Suburban", image: "assets/visualmap/Q3/Q3R2.png" },
            { label: "Rural", image: "assets/visualmap/Q3/Q3R3.png" },
          ],
        },
        {
          question:
            "Our parent community has been very supportive of our student technology program.",
          type: "radiogroup",
          visualized: true,
          selected: "",
          options: [
            { label: "Strongly Agree", image: "assets/visualmap/Q4/Q4R1.png" },
            { label: "Agree", image: "assets/visualmap/Q4/Q4R2.png" },
            { label: "Neutral", image: "assets/visualmap/Q4/Q4R3.png" },
            { label: "Disagree", image: "assets/visualmap/Q4/Q4R4.png" },
            { label: "Strongly Disagree", image: "assets/visualmap/Q4/Q4R5.png" },
          ],
        },
        {
          question: "Our school community is highly resilient.",
          type: "radiogroup",
          visualized: true,
          selected: "",
          options: [
            { label: "Strongly agree", image: "assets/visualmap/Q5/Q5R1.png" },
            { label: "Agree", image: "assets/visualmap/Q5/Q5R2.png" },
            { label: "Neutral", image: "assets/visualmap/Q5/Q5R3.png" },
            { label: "Disagree", image: "assets/visualmap/Q5/Q5R4.png" },
            { label: "Strongly disagree", image: "assets/visualmap/Q5/Q5R5.png" },
          ],
        },
        {
          question: "Which of the following best describes your school today?",
          type: "radiogroup",
          visualized: true,
          selected: "",
          options: [
            { label: "Very innovative", image: "assets/visualmap/Q6/Q6R1.png" },
            { label: "Somewhat innovative", image: "assets/visualmap/Q6/Q6R2.png" },
            {
              label: "In the middle of innovative and traditional",
              image: "assets/visualmap/Q6/Q6R3.png",
            },
            {
              label: "Somewhat traditional",
              image: "assets/visualmap/Q6/Q6R4.png",
            },
            { label: "Very traditional", image: "assets/visualmap/Q6/Q6R5.png" },
          ],
        },
        {
          question:
            "Which of the following best describes typical educational technology practices in your school today?",
          type: "radiogroup",
          visualized: true,
          selected: "",
          options: [
            { label: "Very innovative", image: "assets/visualmap/Q7/Q7R1.png" },
            { label: "Somewhat innovative", image: "assets/visualmap/Q7/Q7R2.png" },
            {
              label: "In the middle of innovative and traditional",
              image: "assets/visualmap/Q7/Q7R3.png",
            },
            {
              label: "Somewhat traditional",
              image: "assets/visualmap/Q7/Q7R4.png",
            },
            { label: "Very traditional", image: "assets/visualmap/Q7/Q7R5.png" },
          ],
        },
      ]
}
export default {
    generate
}